import { environment } from 'src/environments/environment';
import { AUTOMATION_ACTION_TYPES, PriorityTokens } from 'src/models';

export const collections = {
  NOTIFICATIONS: 'notifications',
  SERVER_EVENTS: 'server-events',
  APP_CONFIG: 'app-config',
};

export const routes = {
  HOME: 'home',
  PEOPLE: 'people',
  COMPANY_ADMIN: 'admin',
  SUPER_ADMIN: 'super-admin',
  ADMIN: 'admin',
  SLACK_MESSAGE: 'slack-message',
  CUSTOMERS: 'customers',
  DASHBOARD: 'dashboard',
  OUTBOUND: 'outbound',
  INBOX: 'inbox',
  SETTINGS: 'settings',
  TICKET_TYPES: 'ticket-types',
  AUTOMATIONS: 'automations',
  COLLABORATOR_TYPES: 'collaborator-types',
  PROJECTS: 'projects',
  SERVICE_ACCOUNTS: 'service-accounts',
  ANALYTICS: 'analytics',
  KNOWLEDGE_BASE: 'knowledge',
  CHANNELS: 'channels',
  ACCOUNTS: 'accounts',
};

export const INBOX_TYPES = {
  COLLABORATING_ON: 'collaborating-on',
  ALL: 'all',
  ME: 'me',
  UNASSIGNED: 'unassigned',
  FOLLOWING: 'following',
  CLOSED: 'closed',
  EMAIL: 'email',
  IN_APP: 'chat',
  MICROSOFT_TEAMS: 'microsoft-teams',
  SLACK: 'slack',
  INTAKE: 'intake',
  ESCALATIONS: 'escalations',
};

export const PLAN_DATE_STATUS = {
  POLLING: 'polling',
  CONFIRMED: 'confirmed',
};

export const PLAN_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

export enum PlanListType {
  CURRENT,
  PAST,
}

export const PLAN_VENUE_STATUS = {
  SEARCHING: 'searching',
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
};

export const AUTH_CONTEXT = {
  DEFAULT: 'default',
  RSVP: 'rsvp',
  FOLLOW: 'follow',
  REDIRECT: 'redirect',
};

export const AUTH_PROVIDERS = {
  OKTA: 'okta',
  GSUITE: 'gsuite',
  PASSWORD: 'password',
};

export const RSVP_STATUS = {
  WAITING: 'waiting',
  MAYBE: 'maybe',
  DECLINED: 'declined',
  ATTENDING: 'attending',
  INTERESTED: 'interested',
  NOT_INTERESTED: 'not_interested',
  WAITLISTED: 'waitlisted',
};

export const EXPORT_HEADERS_PLANS = [
  'id',
  'title',
  'date',
  'location',
  'createdAt',
  'description',
  'timezone',
  'createdBy',
  'organizerId',
  'attendingCount',
];

export const EXPORT_HEADERS_GUESTS = ['id', 'name', 'email', 'phoneNumber', 'rsvp', 'createdAt', 'planId', 'isHost'];

export const EXPORT_HEADERS_ORGANIZERS = [
  'id',
  'name',
  'category',
  'description',
  'followerCount',
  'createdAt',
  'createdBy',
];

export const CHAT_NOTIFICATION_PREFERENCE = {
  ALL: 'all',
  OFF: 'off',
  HOST_ONLY: 'host-only',
};

export const GUEST_LIST_SHOWN = {
  ALWAYS: 'always',
  RSVPED: 'rsvped',
  NEVER: 'never',
};

export const POST_TYPE = {
  TEXT: 'text',
  SURVEY: 'survey',
};

export const POST_STATUS = {
  PUBLISHED: 'published',
  DRAFT: 'draft',
  IN_REVIEW: 'in_review',
};

export const POST_REACTION_OPTIONS = [
  {
    label: 'Like',
    value: 'like',
    icon: 'thumbs-up',
  },
  {
    label: 'Dislike',
    value: 'dislike',
    icon: 'thumbs-down',
  },
  {
    label: 'Insightful',
    value: 'insightful',
    icon: 'bulb',
  },
  {
    label: 'Heart',
    value: 'heart',
    icon: 'heart',
  },
  {
    label: 'Exciting',
    value: 'exciting',
    icon: 'rocket',
  },
];

export const COMMUNITY_CATEGORIES = [
  {
    displayName: 'Club',
    key: 'club',
  },
  {
    displayName: 'Cultural group',
    key: 'erg',
  },
  {
    displayName: 'Team',
    key: 'team',
  },
  {
    displayName: 'Department',
    key: 'department',
  },
  {
    displayName: 'Office',
    key: 'office',
  },
  {
    displayName: 'Non-profit',
    key: 'nonProfit',
  },
  {
    displayName: 'Resource',
    key: 'resource',
  },
  {
    displayName: 'Project',
    key: 'project',
  },
  {
    displayName: 'Cohort',
    key: 'cohort',
  },
  {
    displayName: 'Venue',
    key: 'venue',
  },
  {
    displayName: 'Other',
    key: 'other',
  },
];

// This is kinda duplicated from above – should do this better
export const COMMUNITY_CATEGORY_MAP = {
  club: 'Clubs',
  erg: 'Cultural groups',
  team: 'Teams',
  cohort: 'Cohorts',
  department: 'Departments',
  office: 'Offices',
  venue: 'Venues',
  other: 'Other',
  nonProfit: 'Non-profits',
  resource: 'Resources',
  project: 'Projects',
};

export const COMMUNITY_MEMBER_LIST_PRIVACY = {
  ALWAYS: 'always',
  MEMBERS: 'members',
  ADMINS: 'admins',
};

export const CUSTOM_FIELD_TYPE_SHORT_ANSWER = 'short-answer';
export const CUSTOM_FIELD_TYPE_LONG_ANSWER = 'long-answer';
export const CUSTOM_FIELD_TYPE_CHECKBOX = 'checkbox';
export const CUSTOM_FIELD_TYPE_SINGLE_SELECT = 'single-select';
export const CUSTOM_FIELD_TYPE_MULTI_SELECT = 'multi-select';
export const CUSTOM_FIELD_TYPE_FILE_UPLOAD = 'file-upload';
export const CUSTOM_FIELD_TYPE_USER_ATTRIBUTE = 'user-attribute';
export const CUSTOM_FIELD_TYPE_USER_SELECT = 'user-select';
export const CUSTOM_FIELD_TYPE_MULTI_USER_SELECT = 'multi-user-select';
export const CUSTOM_FIELD_TYPE_DATE = 'date';
export const CUSTOM_FIELD_TYPE_TEXT = 'text';
export const CUSTOM_FIELD_TYPE_USER_GROUP_SELECT = 'user-group-select';
export const CUSTOM_FIELD_TYPE_MULTI_USER_GROUP_SELECT = 'multi-user-group-select';

export const HOME_FEED_FILTERS = {
  all: {
    display: 'All upcoming',
    icon: 'pulse',
    key: 'all',
  },
  // announcements: {
  //     display: 'Announcement',
  //     icon: 'megaphone',
  //     key: 'announcements',
  // },
  posts: {
    display: 'Discussions',
    icon: 'chatbox-ellipses',
    key: 'posts',
  },
  ergEvents: {
    display: 'Cultural events',
    icon: 'globe',
    key: 'ergEvents',
  },
  clubEvents: {
    display: 'Club events',
    icon: 'basketball',
    key: 'clubEvents',
  },
  pastEvents: {
    display: 'Past events',
    icon: 'reload-circle',
    key: 'pastEvents',
  },
};

export const UPLOAD_STATUS = {
  NONE: 'none',
  PROCESSING: 'processing',
  FAILED: 'failed',
  SUCCESS: 'success',
};

export const TIME_INTERVAL_SECONDS = {
  ONE_HOUR: 3600,
  ONE_DAY: 86400,
  TWO_DAYS: 172800,
  ONE_WEEK: 604800,
};

export const MAX_FILE_SIZE_MB = 5; // MB

export const USER_NOTIFICATION_TYPES = {
  NEW_INVITE: 'newInvite',
  EVENT_UPDATED: 'planUpdated',
  EVENT_CANCELED: 'planCanceled',
  EVENT_CHAT_RECEIVED: 'chatReceived',
  GUEST_RSVP_UPDATED: 'rsvpUpdated',
  GUEST_SURVEY_UPDATED: 'surveyUpdated',
  COMMUNITY_MEMBER_FOLLOW: 'communityMemberFollow',
  COMMUNITY_MEMBER_UNFOLLOW: 'communityMemberUnfollow',
  COMMUNITY_MEMBER_UPLOAD_SUCCEEDED: 'communityMemberUploadSucceeded',
  COMMUNITY_MEMBER_UPLOAD_FAILED: 'communityMemberUploadFailed',
  SURVEY_RESPONSE_UPDATED: 'surveyResponseUpdated',
  OUTBOUND_SURVEY_RECEIVED: 'outboundSurveyResponseReceived',
  CREATE_CUSTOMER_FAILED: 'createCustomerFailed',
  CREATE_CUSTOMER_SUCCEEDED: 'createCustomerSucceeded',
  EXTERNAL_TASK_COMPLETED: 'externalTaskCompleted',
  BULK_CONVERSATION_UPDATE_SUCCEEDED: 'bulkConversationUpdateSucceeded',
  BULK_CONVERSATION_UPDATE_FAILED: 'bulkConversationUpdateFailed',
  OUTBOUND_SEND_SUCCEEDED: 'outboundSendSucceeded',
  OUTBOUND_SEND_FAILED: 'outboundSendFailed',
};

export const ZOOM_OAUTH_URL = 'https://zoom.us/oauth/authorize';
export const ZOOM_OAUTH_REDIRECT_URL = `${environment.baseUrl}/integrations/zoom`;
export const ZOOM_AUTH_CODE_PARAM = 'code';

export const VIDEOCONFERENCE_PROVIDERS = {
  ZOOM: 'zoom',
  MEET: 'hangoutsMeet',
};

export const INTEGRATION_TYPES = {
  CRM: 'external-crm',
  TASK_MANAGER: 'external-task-management',
  AUTOMATION: 'automation',
  TICKETING: 'external-support',
  COMMUNICATION: 'communication',
  KNOWLEDGEBASE: 'external-knowledgebase',
  HRIS: 'hris',
  ITSM: 'itsm',
  GOOGLE: 'google',
};

export const INTEGRATION_TYPE_NAMES = {
  [INTEGRATION_TYPES.CRM]: 'CRM',
  [INTEGRATION_TYPES.TASK_MANAGER]: 'Task Management',
  [INTEGRATION_TYPES.AUTOMATION]: 'Automation',
  [INTEGRATION_TYPES.TICKETING]: 'Ticketing',
  [INTEGRATION_TYPES.COMMUNICATION]: 'Communication',
  [INTEGRATION_TYPES.KNOWLEDGEBASE]: 'Docs',
  [INTEGRATION_TYPES.HRIS]: 'HR Tools',
  [INTEGRATION_TYPES.ITSM]: 'IT Tools',
  [INTEGRATION_TYPES.GOOGLE]: 'Google',
};

export const INTEGRATIONS = {
  slack: {
    type: INTEGRATION_TYPES.COMMUNICATION,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fslack.jpg?alt=media&token=8d943478-d2d8-48d9-9846-74033cadd1f7',
    url: 'slack',
    key: 'slack',
    name: 'Slack',
    preview: 'Slack is a key integration to manage customer conversations and assign tickets to your team',
    connect: 'Connect my Slack account',
    installable: true,
  },
  email: {
    type: INTEGRATION_TYPES.COMMUNICATION,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Femail.jpg?alt=media&token=465697f9-4691-42d0-8d9f-7dda67011398',
    url: 'email',
    key: 'email',
    name: 'Email',
    preview:
      'Forward incoming emails to an internal Slack channel, discuss internally, and compose your reply right from Slack',
    connect: 'Configure',
    installable: true,
  },
  widget: {
    type: INTEGRATION_TYPES.COMMUNICATION,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fchat.jpg?alt=media&token=9922df67-15c0-4edd-9fda-15a8a1c9f0ec',
    url: 'in-app-chat',
    key: 'widget',
    name: 'In-app Chat Widget',
    preview:
      'Embed live chat into your application, and messages will be posted into a Slack channel where your team can reply',
    connect: 'Configure',
    installable: true,
  },
  microsoftTeams: {
    type: INTEGRATION_TYPES.COMMUNICATION,
    isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fteams.jpg?alt=media&token=7bd743dc-65dc-48c9-9e91-0481a7e6df3a',
    url: 'microsoft-teams',
    key: 'microsoft-teams',
    name: 'Microsoft Teams',
    preview:
      'Forward incoming messages in Microsoft Teams channels to an internal Slack channel, discuss internally, and compose your reply right from Slack',
    connect: 'Configure',
    installable: true,
  },
  zapier: {
    type: INTEGRATION_TYPES.AUTOMATION,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fzapier.jpg?alt=media&token=6472fc0f-53e7-4c51-9499-2c2e053b337c',
    url: 'service-accounts',
    key: 'zapier',
    name: 'Zapier',
    preview: 'Zapier is a powerful no-code / low-code tool to link your Unthread account to thousands of applications',
    connect: 'Connect to Zapier',
    installable: true,
  },
  make: {
    type: INTEGRATION_TYPES.AUTOMATION,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fmake.png?alt=media&token=001b6588-390e-406e-93a7-d708beb8ecb5',
    url: 'service-accounts',
    key: 'make',
    name: 'Make',
    preview: 'Make is a powerful no-code / low-code tool to link your Unthread account to thousands of applications',
    connect: 'Connect to Make',
    // isBeta: true,
    installable: false,
  },
  webhooks: {
    type: INTEGRATION_TYPES.AUTOMATION,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fwebhooks.jpg?alt=media&token=5e58829a-128a-49d8-a553-e5a0cb9ec716',
    url: 'webhooks',
    key: 'webhooks',
    name: 'API & Webhooks',
    preview:
      'Built powerful, custom workflows by integrating with the Unthread API and Webhooks for real-time changes and updates',
    connect: 'Enable webhooks',
    installable: true,
  },
  ai: {
    type: INTEGRATION_TYPES.COMMUNICATION,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fai.jpg?alt=media&token=ea532bce-8818-4c86-93b9-3d12ea630313',
    url: 'ai',
    key: 'ai',
    name: 'Unthread AI',
    preview: 'Use the latest in generative AI to automatically generate responses and categorize your customer issues',
    connect: 'Enable AI',
    installable: true,
  },
  hubspot: {
    type: INTEGRATION_TYPES.CRM,
    // isBeta: true,
    isNango: true,
    registerIntegration: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fhubspot.jpg?alt=media&token=8fde6960-b18c-4f02-805e-aad733594c83',
    // url: 'hubspot',
    key: 'hubspot',
    name: 'Hubspot',
    preview: 'Sync conversations from Slack to Hubspot, and link your Hubspot customers to your customer channels',
    connect: 'Connect to Hubspot',
    installable: true,
    documentation: 'https://docs.unthread.io/integrations/hubspot',
    userInput: [
      {
        label: 'HubSpot object type to sync with (companies, deals)',
        key: 'objectType',
        required: false,
        type: 'dropdown',
        default: 'companies',
        options: [
          {
            label: 'Companies',
            value: 'companies',
          },
          {
            label: 'Deals',
            value: 'deals',
          },
        ],
      },
      {
        label: 'HubSpot object to create for new conversation (call, email)',
        key: 'engagementType',
        required: false,
        type: 'dropdown',
        default: 'call',
        options: [
          {
            label: 'Call',
            value: 'call',
          },
          {
            label: 'Email',
            value: 'email',
          },
          {
            label: 'SMS',
            value: 'sms',
          },
        ],
      },
      {
        label: 'Slack Channel ID field in HubSpot (to enable auto-syncing)',
        key: 'slackChannelId',
        required: false,
        format: 'snakeCase',
        helper:
          "Look in HubSpot for the ID of this field, which should be formatted with underscores, e.g. 'slack_channel_id'",
      },
      {
        label: 'Sync Primary Support Rep from HubSpot?',
        key: 'syncPrimarySupportRep',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'What field in HubSpot maps to Primary Support rep in Unthread?',
        key: 'primarySupportRepField',
        required: false,
        default: 'hubspot_owner_id',
        format: 'snakeCase',
        helper:
          "Look in HubSpot for the ID of this field, which should be formatted with underscores; e.g. 'hubspot_owner_id'",
      },
    ],
  },
  vitally: {
    type: INTEGRATION_TYPES.CRM,
    isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fvitally.jpg?alt=media&token=7affb095-7896-4ac6-9190-bffc3e719e87',
    key: 'vitally',
    name: 'Vitally',
    title: 'Sync conversations to Vitally',
    bullets: [
      'Automatically sync all customer conversations to Vitally',
      'Track conversation history in customer profiles',
      'Support for both customer and admin message routing',
      'Real-time conversation and message synchronization',
    ],
    preview:
      'Sync conversations in Unthread to Vitally, and see conversation history for each customer in their Vitally profile. Conversations are automatically created and messages are synced in real-time.',
    connect: 'Connect to Vitally',
    installable: true,
    registerIntegration: true,
    userInput: [
      {
        label: 'Vitally Subdomain',
        key: 'subdomain',
        required: true,
        placeholder: 'your-company',
        helper: 'Enter your Vitally subdomain (e.g., "your-company" for your-company.rest.vitally.io)',
        type: 'text',
      },
      {
        label: 'API Key',
        key: 'apiKey',
        type: 'secret',
        required: true,
        helper: 'Enter your Basic Vitally API key (Do NOT include "Basic " prefix)',
        placeholder: 'XYZ123ABC123==',
      },
      {
        label: 'Default Admin Email',
        key: 'defaultAdminEmail',
        required: true,
        placeholder: 'admin@yourcompany.com',
        helper: 'Default admin email for conversations when no specific admin is assigned',
        type: 'text',
      },
    ],
  },
  jira: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fjira.jpg?alt=media&token=c6987224-d314-423c-a482-d17c3656b4f4',
    isNango: true,
    registerIntegration: true,
    // url: 'jira',
    key: 'jira',
    name: 'JIRA Cloud',
    preview:
      'Use Jira Cloud to automatically create JIRA issues from your Slack conversations and track statuses from the Unthread inbox',
    connect: 'Connect to JIRA',
    userInput: [
      {
        label: 'Site Name',
        key: 'siteName',
        required: true,
        helper:
          'The subdomain of the Jira instance to connect to. For example, if your Jira instance is at https://mycompany.atlassian.net, the site name is "mycompany"',
      },
      {
        label: 'Project Keys - Comma-separated list of project keys to sync, e.g. "PROJ1,PROJ2"',
        key: 'projectKeys',
        required: true,
      },
      {
        label: 'Move conversation to open when task completed?',
        key: 'moveToOpenOnComplete',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Post task status changes to Slack triage thread?',
        key: 'postStatusToTriage',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Post triage messages in Slack to issue as comments?',
        key: 'syncTriageMessagesToTask',
        default: false,
        type: 'checkbox',
      },
      {
        label: 'Sync Jira comments to Slack triage thread?',
        key: 'syncCommentsToConversation',
        default: false,
        type: 'checkbox',
      },
      {
        label: 'Post messages in primary Slack thread to issue as comments?',
        key: 'syncMessagesToTask',
        default: false,
        type: 'checkbox',
      },
    ],
    documentation: 'https://docs.unthread.io/integrations/task-managers',
    installable: true,
  },
  jiraDataCenter: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fjira-dc.jpg?alt=media&token=57e3f65c-4fa2-4df2-99c4-03caa52c7420',
    isNango: false,
    registerIntegration: true,
    key: 'jiraDataCenter',
    name: 'JIRA Data Center',
    preview:
      'Use Jira on a hosted Data Center instance. Automatically create JIRA issues from your Slack conversations and track statuses from the Unthread inbox',
    connect: 'Connect to JIRA',
    userInput: [
      {
        label: 'Domain',
        key: 'domain',
        required: true,
        helper: "It likely looks something like 'https://jira.mycompany.com'",
      },
      {
        label: 'Version',
        key: 'version',
        required: true,
        helper: 'Example: 9.12.14',
      },
      {
        label: 'API Token',
        key: 'apiToken',
        type: 'secret',
        required: true,
      },
      {
        label: 'Project Keys - Comma-separated list of project keys to sync, e.g. "PROJ1,PROJ2"',
        key: 'projectKeys',
        required: true,
      },
      {
        label: 'Move conversation to open when task completed?',
        key: 'moveToOpenOnComplete',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Post task status changes to Slack triage thread?',
        key: 'postStatusToTriage',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Post triage messages in Slack to issue as comments?',
        key: 'syncTriageMessagesToTask',
        default: false,
        type: 'checkbox',
      },
      {
        label: 'Sync Jira comments to Slack triage thread?',
        key: 'syncCommentsToConversation',
        default: false,
        type: 'checkbox',
      },
      {
        label: 'Post customer messages to issue as comments?',
        key: 'syncMessagesToTask',
        default: false,
        type: 'checkbox',
      },
    ],
    documentation: 'https://docs.unthread.io/integrations/task-managers',
    installable: true,
  },
  linear: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Flinear.jpg?alt=media&token=9dab2fbf-4f32-4e86-8fd0-3286cf33e8b3',
    isNango: true,
    registerIntegration: true,
    // url: 'linear',
    key: 'linear',
    name: 'Linear',
    preview:
      'Automatically create Linear issues from your Slack conversations and track statuses from the Unthread inbox',
    connect: 'Connect to Linear',
    userInput: [
      {
        label: 'Move conversation to open when task completed?',
        key: 'moveToOpenOnComplete',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Post task status changes to Slack triage thread?',
        key: 'postStatusToTriage',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Sync Linear comments to Slack triage thread?',
        key: 'syncCommentsToConversation',
        default: false,
        type: 'checkbox',
      },
      {
        label: 'Post triage messages in Slack to issue as comments?',
        key: 'syncTriageMessagesToTask',
        default: false,
        type: 'checkbox',
      },
      {
        label: 'Post customer messages to issue as comments?',
        key: 'syncMessagesToTask',
        default: false,
        type: 'checkbox',
      },
    ],
    documentation: 'https://docs.unthread.io/integrations/task-managers',
    installable: true,
    authorizationParams: {
      actor: 'application',
    },
  },
  shortcut: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fshortcut.jpg?alt=media&token=ed5c75a9-270a-499f-8de6-99113257cbc5',
    registerIntegration: true,
    // url: 'shortcut',
    key: 'shortcut',
    name: 'Shortcut',
    preview:
      'Automatically create Shortuct stories from your Slack conversations and track statuses from the Unthread inbox',
    connect: 'Connect to Shortuct',
    userInput: [
      {
        label: 'API Token',
        key: 'apiToken',
        type: 'secret',
        required: true,
      },
      {
        label: 'Post task status changes to Slack triage thread?',
        key: 'postStatusToTriage',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Move conversation to open when task completed?',
        key: 'moveToOpenOnComplete',
        default: true,
        type: 'checkbox',
      },
    ],
    documentation: 'https://docs.unthread.io/integrations/task-managers',
    installable: true,
  },
  asana: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fasana.jpg?alt=media&token=bb7bc15c-bb3e-4d08-9385-386c9ba6a4b7',
    // url: 'asana',
    key: 'asana',
    name: 'Asana',
    title: 'Track tasks on Asana',
    bullets: [
      "Post events & reminders to your community's Slack channel",
      'Share posts and other updates instantly',
      'Sync your Slack members with your community member list',
    ],
    preview:
      'Automatically create Asana tasks from your Slack conversations and track statuses from the Unthread inbox',
    connect: 'Connect to Asana',
    isNango: true,
    registerIntegration: true,
    installable: true,
    documentation: 'https://docs.unthread.io/integrations/task-managers',
    userInput: [
      {
        label: 'Asana Project Names (comma-separated)',
        key: 'projectNames',
        required: true,
      },
      {
        label: 'Post task status changes to Slack triage thread?',
        key: 'postStatusToTriage',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Move conversation to open when task completed?',
        key: 'moveToOpenOnComplete',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Sync Asana comments to Slack triage thread?',
        key: 'syncCommentsToConversation',
        default: false,
        type: 'checkbox',
      },
      {
        label: 'Post triage messages in Slack to task as comments?',
        key: 'syncTriageMessagesToTask',
        default: false,
        type: 'checkbox',
      },
      {
        label: 'Post customer messages to task as comments?',
        key: 'syncMessagesToTask',
        default: false,
        type: 'checkbox',
      },
    ],
  },
  github: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fgithub.jpg?alt=media&token=e0ece699-b344-48bb-b26c-762f2812a59a',
    // url: 'github',
    key: 'github',
    name: 'GitHub',
    title: 'Track issues on GitHub',
    bullets: [],
    preview:
      'Automatically create GitHub issues from your Slack conversations and track statuses from the Unthread inbox. You must be a GitHub organization owner in order to install this integration.',
    connect: 'Connect to GitHub',
    registerIntegration: true,
    installable: true,
    isNango: true,
    documentation: 'https://docs.unthread.io/integrations/task-managers',
    userInput: [
      {
        label: 'GitHub Organization Name',
        key: 'orgName',
        required: true,
      },
    ],
  },
  monday: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fmonday.com.png?alt=media&token=fdccc74a-8552-425d-ba47-a8e0289f1fb3',
    // url: 'asana',
    key: 'monday',
    name: 'Monday.com',
    title: 'Track tasks on Monday.com',
    bullets: [
      "Post events & reminders to your community's Slack channel",
      'Share posts and other updates instantly',
      'Sync your Slack members with your community member list',
    ],
    preview:
      'Visit the <a target="_blank" href="https://auth.monday.com/oauth2/authorize?client_id=6b9aa39056a740d17a9d64b38f7e7d19&response_type=install"/>Unthread app installation page</a> to install our app in your Monday.com workspace. Automatically create Monday.com tasks from your Slack conversations and track statuses from the Unthread inbox.',
    connect: 'Connect to Monday.com',
    isNango: true,
    registerIntegration: true,
    installable: true,
    documentation: 'https://docs.unthread.io/integrations/task-managers',
    userInput: [
      {
        label: 'Monday.com Board IDs (comma-separated)',
        key: 'boardIds',
        required: true,
      },
      {
        label: 'Post task status changes to Slack triage thread?',
        key: 'postStatusToTriage',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Move conversation to open when task completed?',
        key: 'moveToOpenOnComplete',
        default: true,
        type: 'checkbox',
      },
    ],
  },
  height: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fheight.jpg?alt=media&token=4ee9de3f-0292-42da-b54e-aa8fcf46cfb8',
    // url: 'height',
    key: 'height',
    name: 'Height',
    title: 'Track tasks on Height',
    bullets: [],
    preview:
      'Automatically create Height tasks from your Slack conversations and track statuses from the Unthread inbox',
    connect: 'Connect to Height',
    installable: true,
    registerIntegration: true,
    documentation: 'https://docs.unthread.io/integrations/task-managers',
    userInput: [
      {
        label: 'API Token',
        key: 'apiToken',
        type: 'secret',
        required: true,
      },
      {
        label: 'Post task status changes to Slack triage thread?',
        key: 'postStatusToTriage',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Move conversation to open when task completed?',
        key: 'moveToOpenOnComplete',
        default: true,
        type: 'checkbox',
      },
    ],
  },
  clickup: {
    type: INTEGRATION_TYPES.TASK_MANAGER,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fclickup.jpg?alt=media&token=80b327a9-43e5-4b06-95cd-fa24c0865553',
    // url: 'clickup',
    key: 'clickup',
    isNango: true,
    registerIntegration: true,
    name: 'ClickUp',
    title: 'Track tasks on ClickUp',
    bullets: [],
    preview:
      'Automatically create ClickUp tasks from your Slack conversations and track statuses from the Unthread inbox',
    connect: 'Connect to ClickUp',
    installable: true,
    userInput: [
      {
        label: 'Post task status changes to Slack triage thread?',
        key: 'postStatusToTriage',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Move conversation to open when task completed?',
        key: 'moveToOpenOnComplete',
        default: true,
        type: 'checkbox',
      },
    ],
  },
  // strac: {
  //   type: INTEGRATION_TYPES.PRIVACY,
  //   isBeta: true,
  //   imageSrc:
  //     'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fstrac.jpg?alt=media&token=2db326d4-9e15-4910-ad8f-2074e77809ff',
  //   // url: 'strac',
  //   key: 'strac',
  //   name: 'Data Redaction (by Strac)',
  //   title: 'Limit PII with Strac',
  //   bullets: [
  //     "Post events & reminders to your community's Slack channel",
  //     'Share posts and other updates instantly',
  //     'Sync your Slack members with your community member list',
  //   ],
  //   preview:
  //     'Redact sensitive information like PII & PHI from Slack messages to reduce exposure of important files, passwords, and more',
  //   connect: 'Connect to Strac',
  //   installable: false,
  // },
  zendesk: {
    type: INTEGRATION_TYPES.TICKETING,
    // isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fzendesk.jpg?alt=media&token=8b01c8d2-318c-4935-b5d6-af0978044fb2',
    // url: 'zendesk',
    key: 'zendesk',
    isNango: true,
    registerIntegration: true,
    name: 'Zendesk',
    title: 'Create tickets in Zendesk',
    bullets: [],
    preview: 'Create Zendesk tickets from your Slack conversations and sync replies back to Slack.',
    connect: 'Connect to Zendesk',
    userInput: [
      {
        label: 'Zendesk Subdomain',
        key: 'subdomain',
        required: true,
        isNangoConfig: true,
      },
      {
        label: 'Sync all conversations to Zendesk?',
        key: 'autoSyncNewConversations',
        default: true,
        type: 'checkbox',
      },
    ],
    documentation: 'https://docs.unthread.io/integrations/zendesk',
    installable: true,
  },
  freshservice: {
    type: INTEGRATION_TYPES.TICKETING,
    isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Ffreshservice.jpg?alt=media&token=b4944078-8bea-4cb2-b6c1-50a3d10729b3',
    key: 'freshservice',
    name: 'Freshdesk & Freshservice',
    title: 'Create tickets in Freshservice',
    bullets: [],
    preview: 'Create Freshservice tickets from your Slack conversations and sync replies back to Slack.',
    connect: 'Connect',
    installable: false,
  },
  salesforce: {
    type: INTEGRATION_TYPES.CRM,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fsalesforce.jpg?alt=media&token=8b0a7148-0ca3-44da-bd2f-099054f972d3',
    key: 'salesforce',
    isNango: true,
    registerIntegration: true,
    name: 'Salesforce',
    title: 'Push activity to Salesforce',
    bullets: [],
    preview: 'Sync accounts from Salesforce and push activity from Slack to Salesforce.',
    connect: 'Connect to Salesforce',
    documentation: 'https://docs.unthread.io/integrations/salesforce',
    userInput: [
      {
        label:
          'Slack Channel field in Salesforce (to enable auto-syncing). This can be the channel ID or channel name.',
        key: 'slackChannelId',
        placeholder: 'Slack_Channel_ID__c',
        required: false,
      },
      {
        label:
          'Update Slack Channel ID in Salesforce? Check this if you want to update the Slack channel ID in Salesforce when manually linking customers from Unthread.',
        key: 'syncBackSlackChannelId',
        default: true,
        type: 'checkbox',
      },
      {
        label:
          'Using Account Teams in Salesforce? Check this if you use the "Account Teams" feature in Salesforce and want to sync primary and secondary support reps based on the account team roles.',
        key: 'useAccountTeams',
        default: true,
        type: 'checkbox',
      },
      {
        label: 'Sync Primary Support Rep from Salesforce?',
        key: 'syncPrimarySupportRep',
        default: true,
        type: 'checkbox',
      },
      {
        label:
          'Field in Salesforce that maps to the primary support rep in Unthread (e.g. Owner or Primary_Support_Rep__c).',
        key: 'primarySupportRepField',
        required: false,
        default: 'Owner',
        hide: (config) => config.useAccountTeams || !config.syncPrimarySupportRep,
      },
      {
        label: 'Account team role in Salesforce that maps to the primary support rep in Unthread.',
        key: 'primarySupportRepTeamRole',
        required: false,
        default: 'Account Manager',
        hide: (config) => !config.useAccountTeams || !config.syncPrimarySupportRep,
      },
      {
        label: 'Sync Secondary Support Rep from Salesforce?',
        key: 'syncSecondarySupportRep',
        default: false,
        type: 'checkbox',
      },
      {
        label:
          'Field in Salesforce that maps to the secondary support rep in Unthread. (e.g. Owner or Secondary_Support_Rep__c)',
        key: 'secondarySupportRepField',
        required: false,
        hide: (config) => config.useAccountTeams || !config.syncSecondarySupportRep,
      },
      {
        label: 'Account team role in Salesforce that maps to the secondary support rep in Unthread.',
        key: 'secondarySupportRepTeamRole',
        required: false,
        placeholder: 'Account Coordinator',
        hide: (config) => !config.useAccountTeams || !config.syncSecondarySupportRep,
      },
      {
        label: 'User type to create in Salesforce',
        key: 'contactType',
        required: false,
        default: 'contact',
        type: 'dropdown',
        options: [
          {
            label: 'Contact',
            value: 'contact',
          },
          {
            label: 'Lead',
            value: 'lead',
          },
        ],
      },
      {
        label: 'Map Salesforce fields to account custom fields',
        key: 'accountFieldMappings',
        required: false,
        type: 'fieldMapping',
        helper: 'Automatically sync Salesforce account fields to Unthread account custom fields.',
        fieldMappingConfig: {
          externalFieldLabel: 'Salesforce Account Field',
          externalFieldPlaceholder: 'External_Field_Name__c',
          internalFieldLabel: 'Unthread Account Custom Field',
          internalFieldPopoverType: 'accountCustomFields',
        },
        default: [],
      },
    ],
    installable: true,
  },
  notion: {
    type: INTEGRATION_TYPES.KNOWLEDGEBASE,
    url: 'knowledge/sources',
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fnotion.png?alt=media&token=a5d5e1df-597a-4d9e-b91a-61bb1d81c9c6',
    key: 'notion',
    name: 'Notion',
    title: 'Sync your documentation from your Notion workspace into Unthread for AI-generated responses.',
    bullets: [],
    installable: true,
    isNango: true,
    registerIntegration: true,
    preview: 'Sync your documentation from your Notion workspace into Unthread for AI-generated responses.',
    connect: 'Connect to Notion',
    userInput: [
      {
        label: 'Is only for internal use?',
        key: 'isInternal',
        default: true,
        type: 'checkbox',
      },
    ],
    multipleConnections: true,
    isProjectSpecific: true,
  },
  jsm: {
    type: INTEGRATION_TYPES.TICKETING,
    url: 'jsm',
    // todo eng-5251 switch this out to jsm image
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fjira.jpg?alt=media&token=c6987224-d314-423c-a482-d17c3656b4f4',
    key: 'jsm',
    name: 'Jira Service Management',
    installable: true,
    isNango: true,
    title:
      'Use Jira Service Management to automatically create JIRA issues from your Slack conversations and track statuses from the Unthread inbox',
    preview:
      'Use Jira Service Management to automatically create JIRA issues from your Slack conversations and track statuses from the Unthread inbox',
    connect: 'Connect to JSM',
    bullets: [],
    isProjectSpecific: true, // todo eng-5251 not sure
    multipleConnections: false, // todo eng-5251 not sure
  },
  confluence: {
    type: INTEGRATION_TYPES.KNOWLEDGEBASE,
    url: 'knowledge/sources',
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fconfluence.png?alt=media&token=c163c30a-1bbb-411c-a057-4a12cfd67dd2',
    key: 'confluence',
    name: 'Confluence',
    title: 'Sync your docs and wiki pages from your Confluence database into Unthread for AI-generated responses.',
    bullets: [],
    preview: 'Sync your docs and wiki pages from your Confluence database into Unthread for AI-generated responses.',
    connect: 'Connect to Conflence',
    installable: true,
    isNango: true,
    registerIntegration: true,
    userInput: [
      {
        label: 'Site Name',
        key: 'siteName',
        required: true,
        helper:
          'The subdomain of the Confluence instance to connect to. For example, if your Confluence instance is at https://mycompany.atlassian.net, the site name is "mycompany"',
      },
      {
        label: 'Page IDs (comma-separated)',
        key: 'pageIdsAllowlist',
        placeholder: '134322,245344,356855',
        required: true,
        helper:
          'Enter the top-level page ID of any pages or folders to sync. To find a page ID, look in the URL for a short number.',
      },
    ],
    multipleConnections: true,
    isProjectSpecific: true,
  },
  googleDrive: {
    type: INTEGRATION_TYPES.KNOWLEDGEBASE,
    url: 'knowledge/sources',
    isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fdrive.jpg?alt=media&token=8f5e3bda-6736-4ef0-b506-3361f3e3b58f',
    key: 'google-drive',
    name: 'Google Drive',
    title: 'Sync your docs and wiki pages from Google Drive into Unthread for AI-generated responses.',
    bullets: [],
    preview: 'Sync your docs and wiki pages from Google Drive into Unthread for AI-generated responses.',
    connect: 'Connect to Google Drive',
    installable: true,
    isNango: true,
    registerIntegration: true,
    userInput: [
      {
        label: 'Shared Drive IDs (comma-separated)',
        key: 'sharedDriveIds',
        placeholder: '134322,245344,356855',
        required: false,
        helper:
          'Enter the IDs of any shared drive you want to sync from. To find a shared drive ID, look in the URL for text that looks like 0AFNOnJ9Mo62XUk9PVA.',
      },
    ],
    multipleConnections: true,
    isProjectSpecific: true,
  },
  workos: {
    type: INTEGRATION_TYPES.HRIS,
    isBeta: false,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fdirectory-sync.jpg?alt=media&token=e1bf79ab-efc2-4692-9a6c-ed9b6bc1c62c',
    key: 'workos',
    name: 'HR Directory Sync',
    title:
      'Sync employee records with an HR system like Workday, Okta, PeopleSoft, Azure AD, and others for real-time updates.',
    bullets: [],
    preview:
      'Sync employee records with an HR system like Workday, Okta, PeopleSoft, Azure AD, and others for real-time updates.',
    connect: 'Connect',
    installable: true,
    isNango: false,
    registerIntegration: true,
  },
  procurement: {
    type: INTEGRATION_TYPES.ITSM,
    isBeta: true,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fhardware.jpg?alt=media&token=4998c2ea-a007-495d-9036-4ce101ebc527',
    key: 'owner',
    name: 'Hardware Procurement',
    title: 'Get bulk discounts and automate purchasing of hardware through our parter vendors.',
    bullets: [],
    preview: 'Get bulk discounts and automate purchasing of hardware through our parter vendors.',
    connect: 'Connect',
    installable: false,
    isNango: false,
    registerIntegration: false,
  },
  google: {
    type: INTEGRATION_TYPES.GOOGLE,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fgoogle.png?alt=media&token=931fb28f-bc4d-400e-ae5c-3489360eeac3',
    key: 'google',
    name: 'Google',
    preview: 'Connect to Google APIs using a service account.',
    connect: 'Configure Service Account',
    installable: true,
    isNango: false,
    registerIntegration: true,
    userInput: [
      {
        label: 'Service Account Email',
        key: 'serviceAccountEmail',
        required: true,
        helper: 'The email address of the Google Cloud service account.',
      },
      {
        label: 'Service Account Private Key (JSON)',
        key: 'privateKeyJson',
        type: 'secret',
        required: true,
        helper: 'Paste the entire JSON key file content here.',
      },
    ],
    documentation: 'https://docs.unthread.io/integrations/google-workspace-service-account',
  }, // Note: User must assign necessary Admin Role (e.g., Group Admin) to this Service Account's Unique ID via Admin SDK API.
  pagerDuty: {
    key: 'pagerDuty',
    name: 'PagerDuty',
    type: INTEGRATION_TYPES.TICKETING,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fpagerduty.jpg?alt=media&token=191c9449-d8e4-41d1-84e0-3e7ff6322d97',
    preview: 'Create and manage PagerDuty incidents directly from Unthread conversations.',
    installable: true,
    registerIntegration: true,
    isNango: false,
    userInput: [
      {
        key: 'apiKey',
        label: 'PagerDuty REST API Key',
        type: 'secret',
        required: true,
        helpText:
          'Create a REST API Key in PagerDuty under Integrations > API Access Keys (v2). Ensure it has read/write permissions for incidents and on-calls if needed.',
        placeholder: 'u+AbCdEfGhIjKlMnOpQrGt...',
      },
      {
        key: 'defaultUserEmail',
        label: 'Default email to use for pages when pager is not in PagerDuty. Must be an email address in PagerDuty.',
        type: 'text',
        required: true,
        placeholder: 'e.g., support@example.com',
      },
      {
        key: 'allowUserPaging',
        label: 'Allow requesters to trigger PagerDuty pages from Slack?',
        type: 'checkbox',
        default: true,
      },
      {
        key: 'requireGuidance',
        label: 'Require users to read and confirm guidance text when paging?',
        type: 'checkbox',
        default: false,
        hide: (config) => !config.allowUserPaging,
      },
      {
        key: 'guidanceText',
        label: 'Guidance text to display when paging (if required)',
        type: 'text',
        required: false,
        placeholder: 'E.g., Only page under these circumstances...',
        hide: (config) => !config.requireGuidance,
      },
      {
        key: 'enableTicketTypeRouting',
        label: 'Enable PagerDuty service routing based on ticket type?',
        type: 'checkbox',
        default: false,
      },
      {
        key: 'notificationIcon',
        label: 'Notification icon',
        type: 'emoji',
        required: false,
        placeholder: 'Icon to display in Slack PagerDuty page notifications',
        helpText: 'Unicode or custom emoji to use in PagerDuty page notifications. Use :emoji_name: for custom emojis.',
        default: '📟',
        hide: (config) => !config.allowUserPaging,
      },
    ],
  },
  wikiJs: {
    type: INTEGRATION_TYPES.KNOWLEDGEBASE,
    url: 'knowledge/sources',
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fwiki-js.png?alt=media&token=4c620acf-3d17-44cf-9ab7-88f440415374',
    key: 'wiki-js',
    name: 'Wiki.js',
    title: 'Sync your documentation from your Wiki.js instance into Unthread for AI-generated responses.',
    bullets: [],
    installable: true,
    isNango: false,
    registerIntegration: true,
    preview: 'Sync your documentation from your Wiki.js instance into Unthread for AI-generated responses.',
    connect: 'Connect to Wiki.js',
    userInput: [
      {
        key: 'apiKey',
        label: 'Wiki.js API Key',
        type: 'secret',
        required: true,
        helper: 'Enter your Wiki.js API key.',
        placeholder: 'u+AbCdEfGhIjKlMnOpQrGt...',
      },
      {
        label: 'Wiki.js Instance URL',
        key: 'instanceUrl',
        required: true,
        placeholder: 'https://docs.mycompany.com',
        type: 'text',
        helper: 'Enter the base URL of your Wiki.js instance (e.g., https://wiki.example.com).',
      },
    ],
    multipleConnections: true,
    isProjectSpecific: true,
  },
  coda: {
    type: INTEGRATION_TYPES.KNOWLEDGEBASE,
    url: 'knowledge/sources',
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fcoda.jpg?alt=media&token=ed3657e1-c010-45db-9348-f21095b9bd89',
    key: 'coda',
    name: 'Coda',
    title: 'Sync your documentation from your Coda instance into Unthread for AI-generated responses.',
    bullets: [],
    installable: true,
    isNango: false,
    registerIntegration: true,
    preview: 'Sync your documentation from your Coda instance into Unthread for AI-generated responses.',
    connect: 'Connect to Coda',
    userInput: [
      {
        key: 'apiKey',
        label: 'Coda API Key',
        type: 'secret',
        required: true,
        helper: 'Enter your Coda API key.',
        placeholder: 'u+AbCdEfGhIjKlMnOpQrGt...',
      },
      {
        label: 'Coda Folder ID',
        key: 'folderId',
        required: false,
        placeholder: 'Enter the ID of the Coda folder you want to sync.',
        type: 'text',
        helper: 'Enter the ID of the Coda folder you want to sync.',
      },
    ],
    multipleConnections: true,
    isProjectSpecific: true,
  },
  microsoftSharePoint: {
    type: INTEGRATION_TYPES.KNOWLEDGEBASE,
    url: 'knowledge/sources',
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fmicrosoft-sharepoint.jpg?alt=media&token=fa7cf67e-59a6-4bf2-b81c-b7a362af80f5',
    key: 'sharepoint-online',
    name: 'Microsoft SharePoint',
    title: 'Sync your documentation from your Microsoft SharePoint instance into Unthread for AI-generated responses.',
    bullets: [],
    installable: true,
    isNango: true,
    registerIntegration: true,
    preview:
      'Sync your documentation from your Microsoft SharePoint instance into Unthread for AI-generated responses.',
    connect: 'Connect to Microsoft SharePoint',
    userInput: [
      {
        label: 'Site IDs (optional, comma-separated)',
        key: 'siteIds',
        placeholder: 'MySite1,MySite2',
        type: 'text',
        required: false,
      },
      {
        label: 'Include Glob (optional)',
        key: 'includeGlob',
        placeholder: '/My Folder/*.docx',
        type: 'text',
        required: false,
      },
      {
        label: 'Mirror SharePoint Permissions',
        key: 'permissionMirroringEnabled',
        type: 'checkbox',
        required: false,
        default: true,
      },
    ],
    multipleConnections: true,
    isProjectSpecific: true,
  },
  okta: {
    type: INTEGRATION_TYPES.ITSM,
    imageSrc:
      'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fapps%2Fokta.jpg?alt=media&token=9d84c47b-0c5e-4a99-b4f2-8a3f1e5a7b6c',
    key: 'okta',
    isNango: false,
    registerIntegration: true,
    name: 'Okta',
    title: 'Connect Okta for user, group, and application management',
    bullets: [
      'Grant and revoke group access using Okta group IDs',
      'Assign applications to users using Okta app IDs',
      'Real-time API calls - no background data syncing required',
      'Configure with group/app IDs from your Okta admin console',
    ],
    preview: 'Connect Okta to enable automated access management through Unthread workflows and automation actions.',
    connect: 'Connect to Okta',
    installable: true,
    documentation: 'https://docs.unthread.io/integrations/okta',
    userInput: [
      {
        label: 'Okta Domain',
        key: 'oktaDomain',
        required: true,
        placeholder: 'your-org.okta.com or https://your-org.okta.com',
        helper: 'Enter your Okta organization domain or full URL',
        type: 'text',
      },
      {
        label: 'API Token',
        key: 'apiToken',
        type: 'secret',
        required: true,
        helper: 'Enter your Okta API token (SSWS token with required permissions)',
        placeholder: '00ABC...',
      },
    ],
  },
};

export const JSM_INTEGRATION_KEY = 'jsm';

export const USER_STATUS_ACTIVE = 'active';
export const USER_STATUS_INACTIVE = 'inactive';

export const DISCOVERABILITY_SETTINGS = {
  NONE: 'none',
  ADMIN: 'admin',
  ALL: 'all',
};

export const OUTBOUND_TYPE = {
  EMAIL: 'email',
  SLACK: 'slack',
};

export const TEMPLATE_TYPE = {
  EMAIL: 'email',
  SLACK: 'slack',
};

export const PLACEHOLDER_IMAGE_SRC =
  'https://firebasestorage.googleapis.com/v0/b/trnout-co.appspot.com/o/assets%2Fno-image.jpeg?alt=media&token=6728d1b3-66ed-4d8e-8527-88e35a8fd1c8';

export const UPLOAD_TYPE = {
  MEMBER_LIST: 'member-list',
  PROFILE_PIC: 'profile-pic',
};

export const OUTBOUND_LEVEL = {
  SYSTEM: 'system',
  TENANT: 'tenant',
  COMMUNITY: 'community',
};

export const OUTBOUND_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  SCHEDULED: 'scheduled',
  FAILED: 'failed',
};

export const OUTBOUND_RECIPIENT_TYPE = {
  EMAIL: 'email',
  COMMUNITY: 'community',
  USER: 'user',
};

export const OUTBOUND_SENDER_TYPE = {
  SELF: 'user',
  SUPPORT_REP: 'support-rep',
};

export const COMMUNITY_MEMBER_SOURCE_TYPE = {
  ALL_PEOPLE: 'all-people',
};

export const CURRENCIES = {
  USD: {
    code: 'USD',
    name: 'US Dollar',
  },
  EUR: {
    code: 'EUR',
    name: 'European Euro',
  },
  GBP: {
    code: 'GBP',
    name: 'British Pound',
  },
  JPY: {
    code: 'JPY',
    name: 'Japanese Yen',
  },
  CHP: {
    code: 'CHP',
    name: 'Swiss Franc',
  },
  AUD: {
    code: 'AUD',
    name: 'Australian Dollar',
  },
  CAD: {
    code: 'CAD',
    name: 'Canadian Dollar',
  },
  CNY: {
    code: 'CNY',
    name: 'Chinese Yuan',
  },
  NZD: {
    code: 'NZD',
    name: 'New Zealand Dollar',
  },
  INR: {
    code: 'INR',
    name: 'Indian Rupee',
  },
  BZR: {
    code: 'BZR',
    name: 'Brazilian Rupee',
  },
  SEK: {
    code: 'SEK',
    name: 'Swedish Krona',
  },
  ZAR: {
    code: 'ZAR',
    name: 'South African Rand',
  },
  HKD: {
    code: 'HKD',
    name: 'Hong Kong Dollar',
  },
  MXN: {
    code: 'MXN',
    name: 'Mexican Peso',
  },
};

export const REMINDER_TYPE = {
  EMAIL_ALL: 'email-all',
  EMAIL_UNRESPONDED: 'email-unresponded',
  SLACK: 'slack',
  TEAMS: 'teams',
  DEFAULT: 'default',
};

export const CONVERSATION_STATUS = {
  INTAKE: 'draft',
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  ON_HOLD: 'on_hold',
  CLOSED: 'closed',
};

export const CONVERSATION_CATEGORY = {
  ISSUE: 'issue',
  FEATURE: 'feature',
  QUESTION: 'question',
  NONE: 'none',
};

export const CONVERSATION_PRIORITY_VALUES = {
  LOW: 3,
  MEDIUM: 5,
  HIGH: 7,
  CRITICAL: 9,
};

export const DEFAULT_PRIORITY_TOKENS: Record<string, PriorityTokens> = {
  LOW: {
    LABEL: 'Low',
    EMOJI: '➖',
    DESCRIPTION: null,
  },
  MEDIUM: {
    LABEL: 'Medium',
    EMOJI: '🟰',
    DESCRIPTION: null,
  },
  HIGH: {
    LABEL: 'High',
    EMOJI: '❗',
    DESCRIPTION: null,
  },
  CRITICAL: {
    LABEL: 'Critical',
    EMOJI: '‼️',
    DESCRIPTION: null,
  },
};

export const FORM_PLACEHOLDER_DESCRIPTIONS = {
  LOW: 'Low priority',
  MEDIUM: 'Medium priority',
  HIGH: 'High priority',
  CRITICAL: 'Critical priority',
};

export const DEFAULT_PRIORITY_LABEL_MAP_FORM: Record<string, PriorityTokens> = {
  LOW: { LABEL: null, EMOJI: null, DESCRIPTION: null },
  MEDIUM: { LABEL: null, EMOJI: null, DESCRIPTION: null },
  HIGH: { LABEL: null, EMOJI: null, DESCRIPTION: null },
  CRITICAL: { LABEL: null, EMOJI: null, DESCRIPTION: null },
};

export const CONVERSATION_PRIORITY_LABEL_MAP = {
  [CONVERSATION_PRIORITY_VALUES.LOW]: DEFAULT_PRIORITY_TOKENS.LOW.LABEL,
  [CONVERSATION_PRIORITY_VALUES.MEDIUM]: DEFAULT_PRIORITY_TOKENS.MEDIUM.LABEL,
  [CONVERSATION_PRIORITY_VALUES.HIGH]: DEFAULT_PRIORITY_TOKENS.HIGH.LABEL,
  [CONVERSATION_PRIORITY_VALUES.CRITICAL]: DEFAULT_PRIORITY_TOKENS.CRITICAL.LABEL,
};

export const SUPPORT_STEP_TYPES = {
  ASSIGNMENT: 'assignment',
  ESCALATION: 'escalation',
  REMINDER: 'reminder',
  TRIAGE: 'triage',
  ADD_FOLLOWER: 'addFollower',
  ADD_COLLABORATOR: 'addCollaborator',
  CREATE_APPROVAL_REQUEST: 'createApprovalRequest',
};

export const SUPPORT_STEP_ASSIGNEE_TYPES = {
  USER: 'user',
  TEAM: 'team',
  GROUP: 'group',
};

export const SUPPORT_STEP_KEYWORDS = {
  CREATED_BY_USER: 'created-by-user',
  PRIMARY_SUPPORT_ASSIGNEE: 'primary-support-assignee',
  SECONDARY_SUPPORT_ASSIGNEE: 'secondary-support-assignee',
  ASSIGNEE_MANAGER: 'assignee-manager',
  SUBMITTER_MANAGER: 'submitter-manager',
};

export const DEFAULT_INITIAL_SUPPORT_STEP = {
  type: SUPPORT_STEP_TYPES.ASSIGNMENT,
  assigneeId: SUPPORT_STEP_KEYWORDS.CREATED_BY_USER,
  assigneeType: SUPPORT_STEP_ASSIGNEE_TYPES.USER,
  minutes: 0,
};

export const DEFAULT_SUPPORT_STEPS = [
  DEFAULT_INITIAL_SUPPORT_STEP,
  {
    type: SUPPORT_STEP_TYPES.TRIAGE,
    minutes: 0,
  },
];

export const EXTERNAL_CHAT_CONNECTION_TYPES = {
  EMAIL: 'email',
  IN_APP_CHAT: 'in-app-chat',
  MICROSOFT_TEAMS: 'microsoft-teams',
  SLACK: 'slack',
};

export const FEATURES = {
  INBOUND_EMAIL: 'inboundEmail',
  SERVICE_ACCOUNTS: 'serviceAccounts',
  OUTBOUND_EMAIL: 'outboundEmail',
  OUTBOUND_SLACK: 'outboundSlack',
  MULTISTEP_ASSIGNMENT_RULES: 'multiStepAssignmentRules',
  WIDGET: 'widget',
  ANALYTICS: 'analytics',
  WEBHOOKS: 'webhooks',
  KNOWLEDGE_BASE_SYNC: 'knowledgeBaseSync',
  WHITELABELED_AUTORESPONDER: 'whitelabeledAutoresponder',
  CRM_INTEGRATIONS: 'crmIntegrations',
  EXTERNAL_TASK_MANAGERS: 'externalTaskManagers',
  EXTERNAL_CHAT_CONNECTIONS: 'externalChatConnections',
  AUTOMATIONS: 'automations',
  AI_ARTICLE_GENERATION: 'aiArticleGeneration',
};

export const STRIPE_PRODUCTS = {
  FREE: {
    name: 'Free',
    stripeProductId: environment.stripePlans.free.productId,
    defaultPriceId: environment.stripePlans.free.priceId,
    userLimit: 1,
  },
  PER_CHANNEL_BASIC: {
    name: 'Basic',
    stripeProductId: environment.stripePlans.basic.productId,
    defaultPriceId: environment.stripePlans.basic.priceIdMax10,
    userLimit10: {
      stripePriceId: environment.stripePlans.basic.priceIdMax10,
      base: '150',
    },
    userLimit25: {
      stripePriceId: environment.stripePlans.basic.priceIdMax25,
      base: '200',
    },
    userLimit50: {
      stripePriceId: environment.stripePlans.basic.priceIdMax50,
      base: '250',
    },
    base: '150',
    bullets: [
      {
        text: '500 conversations per month',
      },
      {
        text: 'Conversation tracking & assignment',
      },
      {
        text: 'Slack Inbox access',
      },
      {
        text: 'SLA and response analytics',
      },
      {
        text: 'Mass Slack outbounding',
      },
      {
        text: 'In-app Chat Widget',
      },
      {
        text: 'Basic integrations with API or Zapier',
      },
      {
        text: 'Shared email inboxes',
        disabled: true,
      },
      {
        text: 'CRM integrations',
        disabled: true,
      },
      {
        text: 'Task manager integrations',
        disabled: true,
      },
      {
        text: 'Webhooks',
        disabled: true,
      },
      {
        text: 'AI-generated responses ✨',
        disabled: true,
      },
    ],
    userLimit: 50,
    restrictedFeatures: [
      FEATURES.OUTBOUND_EMAIL,
      FEATURES.INBOUND_EMAIL,
      FEATURES.WEBHOOKS,
      FEATURES.WHITELABELED_AUTORESPONDER,
      FEATURES.KNOWLEDGE_BASE_SYNC,
      FEATURES.CRM_INTEGRATIONS,
      FEATURES.EXTERNAL_CHAT_CONNECTIONS,
      FEATURES.AUTOMATIONS,
    ],
  },
  PER_CHANNEL_PRO: {
    name: 'Pro',
    stripeProductId: environment.stripePlans.pro.productId,
    stripeVariablePriceId: environment.stripePlans.pro.priceIdMax10,
    userLimit10: {
      stripePriceId: environment.stripePlans.pro.priceIdMax10,
      base: '250',
    },
    userLimit25: {
      stripePriceId: environment.stripePlans.pro.priceIdMax25,
      base: '300',
    },
    userLimit50: {
      stripePriceId: environment.stripePlans.pro.priceIdMax50,
      base: '500',
    },
    base: '250',
    bullets: [
      {
        text: 'Unlimited conversations',
      },
      {
        text: 'Conversation tracking & assignment',
      },
      {
        text: 'Slack Inbox access',
      },
      {
        text: 'SLA and response analytics',
      },
      {
        text: 'Mass Slack outbounding',
      },
      {
        text: 'In-app Chat Widget',
      },
      {
        text: 'Basic integrations with API or Zapier',
      },
      {
        text: 'Shared email inboxes',
      },
      {
        text: 'CRM integrations',
      },
      {
        text: 'Task manager integrations',
      },
      {
        text: 'Webhooks',
      },
      {
        text: 'AI-generated responses ✨',
      },
    ],
    userLimit: 50,
    restrictedFeatures: [FEATURES.OUTBOUND_EMAIL, FEATURES.AUTOMATIONS],
  },
  CONTACT: {
    name: 'Contact us',
    stripeProductId: null,
    bullets: [
      {
        text: 'Custom pricing that scales with you',
      },
      {
        text: 'High volume channel discounts',
      },
      {
        text: 'Custom integrations, SSO, & more',
      },
      {
        text: 'Dedicated account manager',
      },
    ],
    disabled: false,
    restrictedFeatures: [FEATURES.OUTBOUND_EMAIL],
  },
};

export const REPLY_TIMEOUT_MINUTES_DEFAULT = 180;

export const BOT_HANDLING = {
  OFF: 'off',
  ALL: 'all',
};

export const EXTERNAL_TASK_MANAGEMENT_NAMES = {
  ASANA: 'Asana',
  LINEAR: 'Linear',
  CLICKUP: 'ClickUp',
  HEIGHT: 'Height',
  SHORTCUT: 'Shortcut',
  JIRA: 'JIRA',
  GITHUB: 'GitHub',
  MONDAY: 'Monday.com',
};

export const EXTERNAL_TASK_STATE = {
  HAS_INCOMPLETE_TASKS: 'has_incomplete_tasks',
  ALL_TASKS_COMPLETE: 'all_tasks_complete',
};

export const UNTHREAD_SEND_EXTERNAL_PREFIX = '/unthread';
export const UNTHREAD_SEND_EXTERNAL_CC = 'cc';
export const UNTHREAD_SEND_EXTERNAL_BCC = 'bcc';
export const UNTHREAD_SEND_EXTERNAL_CC_REMOVE = '-cc';
export const UNTHREAD_SEND_EXTERNAL_SEND = 'send';

export const MESSAGE_SOURCE_TYPE = {
  SLACK: 'slack',
  EMAIL: 'email',
  WIDGET: 'widget',
  DASHBOARD: 'dashboard',
  TEAMS: 'microsoft-teams',
  SLACK_BOT_DM: 'slack-bot-dm',
  AUTOMATION: 'automation',
  JSM: 'jsm',
};

export const EXTERNAL_TASK_MANAGEMENT_TYPES = {
  ASANA: 'asana',
  LINEAR: 'linear',
  CLICKUP: 'clickup',
  HEIGHT: 'height',
  SHORTCUT: 'shortcut',
  JIRA: 'jira',
  GITHUB: 'github',
  MONDAY: 'monday',
} as const;

export const EXTERNAL_KNOWLEDGE_BASE_TYPES = {
  WEB: 'web',
  CONFLUENCE: 'confluence',
  GOOGLE_DRIVE: 'google-drive',
  NOTION: 'notion',
  WIKI_JS: 'wiki-js', // Added WIKI_JS
  CODA: 'coda',
  MICROSOFT_SHAREPOINT: 'sharepoint-online',
};

export const INBOX_SORT = {
  CREATED_AT_DESCENDING: 'createdAtDesc',
  CREATED_AT_ASCENDING: 'createdAtAsc',
  PRIORITY_DESCENDING: 'priorityDesc',
  PRIORITY_ASCENDING: 'priorityAsc',
  UPDATED_AT_DESCENDING: 'updatedAtDesc',
  LAST_ACTIVITY_AT_DESCENDING: 'lastActivityAtDesc',
};

export const AUTO_ADD_BOT_CONDITION = {
  ALWAYS: 'always',
  NEVER: 'never',
  ASK: 'ask',
};

export const AUTO_ADD_BOT_CHANNEL_TYPE = {
  ALL: 'all',
  SHARED: 'shared',
};

export const AUTOMATION_RUN_STATUSES = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELED: 'canceled',
};

export enum INBOX_LAYOUT_TYPES {
  GRID = 'grid',
  SIDEBAR = 'sidebar',
  TABLE = 'table',
}

export const PROJECT_MEMBER_ROLES = {
  OWNER: 'owner',
  AGENT: 'agent',
  STANDARD: 'standard',
} as const;

export type ProjectMemberRole = (typeof PROJECT_MEMBER_ROLES)[keyof typeof PROJECT_MEMBER_ROLES];

export const PROJECT_MEMBER_ROLE_ICONS = {
  [PROJECT_MEMBER_ROLES.OWNER]: 'shield-checkmark',
  [PROJECT_MEMBER_ROLES.AGENT]: 'body',
  [PROJECT_MEMBER_ROLES.STANDARD]: '',
};

export const PROJECT_MEMBER_ROLE_NAMES = {
  [PROJECT_MEMBER_ROLES.OWNER]: 'Owner',
  [PROJECT_MEMBER_ROLES.AGENT]: 'Agent',
  [PROJECT_MEMBER_ROLES.STANDARD]: 'Standard',
};

export interface Holiday {
  name: string;
  startDate: string; // Using string for now, consider Date if more appropriate
  endDate: string; // Using string for now, consider Date if more appropriate
}

export interface WorkingHours {
  enabled?: boolean;
  intervals?: any[];
  timezone?: string;
  holidays?: Holiday[];
}

export interface ProjectSlackInboxConfig {
  hideProjectInDirectTicketCreation?: boolean;
  suppressManageConversationsSuccessModal?: boolean;
}

export interface TenantSlackInboxConfig {
  disableDirectTicketCreation?: boolean;
  showProjectSelectorFirstOnTicketCreation?: boolean;
  defaultHideProjectsInDirectTicketCreation?: boolean;
  suppressManageConversationsSuccessModal?: boolean;
}

export const CONSUMER_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'googlemail.com',
  'aol.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'me.com',
  'msn.com',
  'verizon.net',
  'ymail.com',
];

export const DATE_RANGE_TYPES = {
  RELATIVE: 'relative',
  ABSOLUTE: 'absolute',
} as const;

export const CHART_DATE_DIMENSIONS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
  TOTAL: 'total',
} as const;

export const CHART_TYPE_VALUES = {
  TOTAL_COUNT: 'totalCount',
  RESPONSE_TIME_MEAN: 'responseTimeMean',
  RESPONSE_TIME_WORKING_MEAN: 'responseTimeWorkingMean',
  RESOLUTION_TIME_MEAN: 'resolutionTimeMean',
  RESOLUTION_TIME_WORKING_MEAN: 'resolutionTimeWorkingMean',
  RESPONSE_TIME_MEDIAN: 'responseTimeMedian',
  RESPONSE_TIME_WORKING_MEDIAN: 'responseTimeWorkingMedian',
  RESOLUTION_TIME_MEDIAN: 'resolutionTimeMedian',
  RESOLUTION_TIME_WORKING_MEDIAN: 'resolutionTimeWorkingMedian',
  CLOSED_COUNT: 'conversationsResolved',
  SENTIMENT_SCORE_MEAN: 'sentimentScoreMean',
  RESPONSE_TIME_P95: 'responseTimeP95',
  RESPONSE_TIME_WORKING_P95: 'responseTimeWorkingP95',
  RESPONSE_TIME_P99: 'responseTimeP99',
  RESPONSE_TIME_WORKING_P99: 'responseTimeWorkingP99',
  RESOLUTION_TIME_P95: 'resolutionTimeP95',
  RESOLUTION_TIME_WORKING_P95: 'resolutionTimeWorkingP95',
  RESOLUTION_TIME_P99: 'resolutionTimeP99',
  RESOLUTION_TIME_WORKING_P99: 'resolutionTimeWorkingP99',
  WAITING_ON_AGENT_TIME_MEAN: 'waitingOnAgentTimeMean',
  WAITING_ON_AGENT_TIME_WORKING_MEAN: 'waitingOnAgentTimeWorkingMean',
  WAITING_ON_AGENT_TIME_MEDIAN: 'waitingOnAgentTimeMedian',
  WAITING_ON_AGENT_TIME_WORKING_MEDIAN: 'waitingOnAgentTimeWorkingMedian',
  WAITING_ON_AGENT_TIME_P95: 'waitingOnAgentTimeP95',
  WAITING_ON_AGENT_TIME_WORKING_P95: 'waitingOnAgentTimeWorkingP95',
  WAITING_ON_AGENT_TIME_P99: 'waitingOnAgentTimeP99',
  WAITING_ON_AGENT_TIME_WORKING_P99: 'waitingOnAgentTimeWorkingP99',
  WAITING_ON_CUSTOMER_TIME_MEAN: 'waitingOnCustomerTimeMean',
  WAITING_ON_CUSTOMER_TIME_WORKING_MEAN: 'waitingOnCustomerTimeWorkingMean',
  WAITING_ON_CUSTOMER_TIME_MEDIAN: 'waitingOnCustomerTimeMedian',
  WAITING_ON_CUSTOMER_TIME_WORKING_MEDIAN: 'waitingOnCustomerTimeWorkingMedian',
  WAITING_ON_CUSTOMER_TIME_P95: 'waitingOnCustomerTimeP95',
  WAITING_ON_CUSTOMER_TIME_WORKING_P95: 'waitingOnCustomerTimeWorkingP95',
  WAITING_ON_CUSTOMER_TIME_P99: 'waitingOnCustomerTimeP99',
  WAITING_ON_CUSTOMER_TIME_WORKING_P99: 'waitingOnCustomerTimeWorkingP99',
  ACTIVE_DURATION_MEAN: 'activeDurationMean',
  ACTIVE_DURATION_WORKING_MEAN: 'activeDurationWorkingMean',
  ACTIVE_DURATION_MEDIAN: 'activeDurationMedian',
  ACTIVE_DURATION_WORKING_MEDIAN: 'activeDurationWorkingMedian',
  ACTIVE_DURATION_P95: 'activeDurationP95',
  ACTIVE_DURATION_WORKING_P95: 'activeDurationWorkingP95',
  ACTIVE_DURATION_P99: 'activeDurationP99',
  ACTIVE_DURATION_WORKING_P99: 'activeDurationWorkingP99',
  ESCALATION_COUNT: 'escalationCount',
  TICKET_TO_ESCALATION_DURATION_MEAN: 'ticketToEscalationDurationMean',
  TICKET_TO_ESCALATION_DURATION_WORKING_MEAN: 'ticketToEscalationDurationWorkingMean',
  TICKET_TO_ESCALATION_DURATION_MEDIAN: 'ticketToEscalationDurationMedian',
  TICKET_TO_ESCALATION_DURATION_WORKING_MEDIAN: 'ticketToEscalationDurationWorkingMedian',
  TICKET_TO_ESCALATION_DURATION_P95: 'ticketToEscalationDurationP95',
  TICKET_TO_ESCALATION_DURATION_WORKING_P95: 'ticketToEscalationDurationWorkingP95',
  TICKET_TO_ESCALATION_DURATION_P99: 'ticketToEscalationDurationP99',
  TICKET_TO_ESCALATION_DURATION_WORKING_P99: 'ticketToEscalationDurationWorkingP99',
  ESCALATION_TO_ACKNOWLEDGEMENT_DURATION_MEAN: 'escalationToAcknowledgementDurationMean',
  ESCALATION_TO_ACKNOWLEDGEMENT_DURATION_WORKING_MEAN: 'escalationToAcknowledgementDurationWorkingMean',
  ESCALATION_TO_ACKNOWLEDGEMENT_DURATION_MEDIAN: 'escalationToAcknowledgementDurationMedian',
  ESCALATION_TO_ACKNOWLEDGEMENT_DURATION_WORKING_MEDIAN: 'escalationToAcknowledgementDurationWorkingMedian',
  ESCALATION_TO_ACKNOWLEDGEMENT_DURATION_P95: 'escalationToAcknowledgementDurationP95',
  ESCALATION_TO_ACKNOWLEDGEMENT_DURATION_WORKING_P95: 'escalationToAcknowledgementDurationWorkingP95',
  ESCALATION_TO_ACKNOWLEDGEMENT_DURATION_P99: 'escalationToAcknowledgementDurationP99',
  ESCALATION_TO_ACKNOWLEDGEMENT_DURATION_WORKING_P99: 'escalationToAcknowledgementDurationWorkingP99',
  ACKNOWLEDGEMENT_TO_RESOLUTION_DURATION_MEAN: 'acknowledgementToResolutionDurationMean',
  ACKNOWLEDGEMENT_TO_RESOLUTION_DURATION_WORKING_MEAN: 'acknowledgementToResolutionDurationWorkingMean',
  ACKNOWLEDGEMENT_TO_RESOLUTION_DURATION_MEDIAN: 'acknowledgementToResolutionDurationMedian',
  ACKNOWLEDGEMENT_TO_RESOLUTION_DURATION_WORKING_MEDIAN: 'acknowledgementToResolutionDurationWorkingMedian',
  ACKNOWLEDGEMENT_TO_RESOLUTION_DURATION_P95: 'acknowledgementToResolutionDurationP95',
  ACKNOWLEDGEMENT_TO_RESOLUTION_DURATION_WORKING_P95: 'acknowledgementToResolutionDurationWorkingP95',
  ACKNOWLEDGEMENT_TO_RESOLUTION_DURATION_P99: 'acknowledgementToResolutionDurationP99',
  ACKNOWLEDGEMENT_TO_RESOLUTION_DURATION_WORKING_P99: 'acknowledgementToResolutionDurationWorkingP99',
};

export const GROUP_BY_OPTIONS = [
  {
    label: 'Daily',
    key: CHART_DATE_DIMENSIONS.DAY,
  },
  {
    label: 'Weekly',
    key: CHART_DATE_DIMENSIONS.WEEK,
  },
  {
    label: 'Monthly',
    key: CHART_DATE_DIMENSIONS.MONTH,
  },
  {
    label: 'Quarterly',
    key: CHART_DATE_DIMENSIONS.QUARTER,
  },
  {
    label: 'Total',
    key: CHART_DATE_DIMENSIONS.TOTAL,
  },
];

export const DATE_OPTION_LABELS = {
  LAST_24_HOURS: 'Last 24 Hours',
  LAST_7_DAYS: 'Last 7 Days',
  LAST_30_DAYS: 'Last 30 Days',
  LAST_90_DAYS: 'Last 90 Days',
  LAST_6_MONTHS: 'Last 6 Months',
  LAST_12_MONTHS: 'Last 12 Months',
  LAST_WEEK: 'Last Week',
  LAST_MONTH: 'Last Month',
  LAST_YEAR: 'Last Year',
  WTD: 'WTD',
  MTD: 'MTD',
  QTD: 'QTD',
  YTD: 'YTD',
  CUSTOM: 'Custom',
} as const;

export const OPTION_LABEL_TO_KEY = {
  [DATE_OPTION_LABELS.LAST_24_HOURS]: 'LAST_24_HOURS',
  [DATE_OPTION_LABELS.LAST_7_DAYS]: 'LAST_7_DAYS',
  [DATE_OPTION_LABELS.LAST_30_DAYS]: 'LAST_30_DAYS',
  [DATE_OPTION_LABELS.LAST_90_DAYS]: 'LAST_90_DAYS',
  [DATE_OPTION_LABELS.LAST_6_MONTHS]: 'LAST_6_MONTHS',
  [DATE_OPTION_LABELS.LAST_12_MONTHS]: 'LAST_12_MONTHS',
  [DATE_OPTION_LABELS.LAST_WEEK]: 'LAST_WEEK',
  [DATE_OPTION_LABELS.LAST_MONTH]: 'LAST_MONTH',
  [DATE_OPTION_LABELS.LAST_YEAR]: 'LAST_YEAR',
  [DATE_OPTION_LABELS.WTD]: 'WTD',
  [DATE_OPTION_LABELS.MTD]: 'MTD',
  [DATE_OPTION_LABELS.QTD]: 'QTD',
  [DATE_OPTION_LABELS.YTD]: 'YTD',
  [DATE_OPTION_LABELS.CUSTOM]: 'CUSTOM',
};

export const RELATIVE_DATE_OPTIONS = new Set([
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_24_HOURS],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_7_DAYS],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_30_DAYS],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_90_DAYS],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_6_MONTHS],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_12_MONTHS],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_WEEK],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_MONTH],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.LAST_YEAR],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.WTD],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.MTD],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.QTD],
  OPTION_LABEL_TO_KEY[DATE_OPTION_LABELS.YTD],
]);

export const DATE_OPTIONS = [
  {
    label: DATE_OPTION_LABELS.LAST_24_HOURS,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.DAY,
    startIndex: 1,
    endIndex: 0,
  },
  {
    label: DATE_OPTION_LABELS.LAST_7_DAYS,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.DAY,
    startIndex: 7,
    endIndex: 1,
  },
  {
    label: DATE_OPTION_LABELS.LAST_30_DAYS,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.DAY,
    startIndex: 30,
    endIndex: 1,
  },
  {
    label: DATE_OPTION_LABELS.LAST_90_DAYS,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.DAY,
    startIndex: 90,
    endIndex: 1,
  },
  {
    label: DATE_OPTION_LABELS.LAST_6_MONTHS,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.MONTH,
    startIndex: 6,
    endIndex: 1,
  },
  {
    label: DATE_OPTION_LABELS.LAST_12_MONTHS,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.MONTH,
    startIndex: 12,
    endIndex: 1,
  },
  {
    label: DATE_OPTION_LABELS.LAST_WEEK,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.WEEK,
    startIndex: 1,
    endIndex: 1,
  },
  {
    label: DATE_OPTION_LABELS.LAST_MONTH,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.MONTH,
    startIndex: 1,
    endIndex: 1,
  },
  {
    label: DATE_OPTION_LABELS.LAST_YEAR,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.YEAR,
    startIndex: 1,
    endIndex: 1,
  },
  {
    label: DATE_OPTION_LABELS.WTD,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.WEEK,
    startIndex: 0,
    endIndex: 0,
  },
  {
    label: DATE_OPTION_LABELS.MTD,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.MONTH,
    startIndex: 0,
    endIndex: 0,
  },
  {
    label: DATE_OPTION_LABELS.QTD,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.QUARTER,
    startIndex: 0,
    endIndex: 0,
  },
  {
    label: DATE_OPTION_LABELS.YTD,
    type: DATE_RANGE_TYPES.RELATIVE,
    period: CHART_DATE_DIMENSIONS.YEAR,
    startIndex: 0,
    endIndex: 0,
  },
  // {
  //   label: 'Yesterday',
  //   type: DATE_RANGE_TYPES.RELATIVE,
  //   period: CHART_DATE_DIMENSIONS.DAY,
  //   startIndex: 1,
  //   endIndex: 1,
  // },
  {
    label: DATE_OPTION_LABELS.CUSTOM,
    type: DATE_RANGE_TYPES.ABSOLUTE,
  },
];

export const UNIT = {
  SECONDS: {
    label: 'Seconds',
    value: 1,
  },

  MINUTES: {
    label: 'Minutes',
    value: 60,
  },
  HOURS: {
    label: 'Hours',
    value: 3600,
  },
};

export const AUTOMATION_ACTION_TYPES_ICONS = {
  [AUTOMATION_ACTION_TYPES.TRIGGER_FUNCTION]: 'code',
  [AUTOMATION_ACTION_TYPES.ADD_CONVERSATION_TAGS]: 'pricetag',
  [AUTOMATION_ACTION_TYPES.REMOVE_CONVERSATION_TAGS]: 'pricetag',
  [AUTOMATION_ACTION_TYPES.ASSIGN_CONVERSATION]: 'person-add',
  [AUTOMATION_ACTION_TYPES.CHANGE_CONVERSATION_STATUS]: 'pulse',
  [AUTOMATION_ACTION_TYPES.CHANGE_CONVERSATION_SUB_STATUS]: 'pulse',
  [AUTOMATION_ACTION_TYPES.ADD_CONVERSATION_FOLLOWER]: 'notifications-circle',
  [AUTOMATION_ACTION_TYPES.REMOVE_CONVERSATION_FOLLOWER]: 'notifications-circle',
  [AUTOMATION_ACTION_TYPES.SET_CONVERSATION_COLLABORATOR]: 'person',
  [AUTOMATION_ACTION_TYPES.SET_CONVERSATION_TICKET_TYPE]: 'ticket',
  [AUTOMATION_ACTION_TYPES.SET_CUSTOM_FIELD]: 'flask',
  [AUTOMATION_ACTION_TYPES.SET_CONVERSATION_PRIORITY]: 'alert-circle',
  [AUTOMATION_ACTION_TYPES.POST_TO_TRIAGE]: 'swap-horizontal',
  [AUTOMATION_ACTION_TYPES.SEND_SLACK_REMINDER]: 'alarm',
  [AUTOMATION_ACTION_TYPES.SEND_SLACK_TEMPLATE]: 'chatbubble',
  [AUTOMATION_ACTION_TYPES.CREATE_APPROVAL_REQUEST]: 'thumbs-up',
  [AUTOMATION_ACTION_TYPES.LOCK_CONVERSATION]: 'lock-closed',
  [AUTOMATION_ACTION_TYPES.EXCLUDE_CONVERSATION_FROM_ANALYTICS]: 'exclude-outline',
  [AUTOMATION_ACTION_TYPES.SEND_CONVERSATION_REMINDER]: 'alarm',
  [AUTOMATION_ACTION_TYPES.WAIT]: 'hourglass',
  [AUTOMATION_ACTION_TYPES.RESTART]: 'refresh-outline',
  [AUTOMATION_ACTION_TYPES.ADD_USER_TO_GOOGLE_GROUP]: 'logo-google',
  [AUTOMATION_ACTION_TYPES.GRANT_OKTA_GROUP_ACCESS]: 'custom-okta',
  [AUTOMATION_ACTION_TYPES.REVOKE_OKTA_GROUP_ACCESS]: 'custom-okta',
  [AUTOMATION_ACTION_TYPES.ASSIGN_OKTA_APPLICATION_ACCESS]: 'custom-okta',
  [AUTOMATION_ACTION_TYPES.REVOKE_OKTA_APPLICATION_ACCESS]: 'custom-okta',
  [AUTOMATION_ACTION_TYPES.SET_SLACK_USER_GROUP_MEMBERSHIP]: 'people-circle',
  [AUTOMATION_ACTION_TYPES.SUMMARIZE_CONVERSATION]: 'sparkles',
  [AUTOMATION_ACTION_TYPES.ADD_REACTION_EMOJI]: 'happy',
  [AUTOMATION_ACTION_TYPES.CREATE_JIRA_TASK]: 'custom-jira',
  [AUTOMATION_ACTION_TYPES.CREATE_CONVERSATION]: 'add-circle',
  [AUTOMATION_ACTION_TYPES.GENERATE_AI_MESSAGE]: 'bulb',
  [AUTOMATION_ACTION_TYPES.CREATE_PAGERDUTY_PAGE]: 'custom-pagerduty',
  [AUTOMATION_ACTION_TYPES.CREATE_ESCALATION]: 'alert-circle',
} as const;

export const AUTOMATION_ACTION_TYPES_LABELS = {
  [AUTOMATION_ACTION_TYPES.TRIGGER_FUNCTION]: 'Custom Function',
  [AUTOMATION_ACTION_TYPES.ADD_CONVERSATION_TAGS]: 'Add Conversation Tags',
  [AUTOMATION_ACTION_TYPES.REMOVE_CONVERSATION_TAGS]: 'Remove Conversation Tags',
  [AUTOMATION_ACTION_TYPES.ASSIGN_CONVERSATION]: 'Assign Conversation',
  [AUTOMATION_ACTION_TYPES.CHANGE_CONVERSATION_STATUS]: 'Set Conversation Status Type',
  [AUTOMATION_ACTION_TYPES.CHANGE_CONVERSATION_SUB_STATUS]: 'Set Conversation Status',
  [AUTOMATION_ACTION_TYPES.ADD_CONVERSATION_FOLLOWER]: 'Add Conversation Follower',
  [AUTOMATION_ACTION_TYPES.REMOVE_CONVERSATION_FOLLOWER]: 'Remove Conversation Follower',
  [AUTOMATION_ACTION_TYPES.SET_CONVERSATION_COLLABORATOR]: 'Set Conversation Collaborator',
  [AUTOMATION_ACTION_TYPES.SET_CONVERSATION_TICKET_TYPE]: 'Set Conversation Ticket Type',
  [AUTOMATION_ACTION_TYPES.SET_CUSTOM_FIELD]: 'Set Custom Field',
  [AUTOMATION_ACTION_TYPES.SET_CONVERSATION_PRIORITY]: 'Set Conversation Priority',
  [AUTOMATION_ACTION_TYPES.POST_TO_TRIAGE]: 'Post to Triage',
  [AUTOMATION_ACTION_TYPES.SEND_SLACK_REMINDER]: 'Send Slack Reminder',
  [AUTOMATION_ACTION_TYPES.SEND_SLACK_TEMPLATE]: 'Send Message',
  [AUTOMATION_ACTION_TYPES.CREATE_APPROVAL_REQUEST]: 'Send Approval Request',
  [AUTOMATION_ACTION_TYPES.LOCK_CONVERSATION]: 'Lock Conversation',
  [AUTOMATION_ACTION_TYPES.EXCLUDE_CONVERSATION_FROM_ANALYTICS]: 'Exclude Conversation from Analytics',
  [AUTOMATION_ACTION_TYPES.SEND_CONVERSATION_REMINDER]: 'Send Conversation Reminder',
  [AUTOMATION_ACTION_TYPES.WAIT]: 'Wait',
  [AUTOMATION_ACTION_TYPES.RESTART]: 'Restart',
  [AUTOMATION_ACTION_TYPES.SET_SLACK_USER_GROUP_MEMBERSHIP]: 'Set Slack User Group Membership',
  [AUTOMATION_ACTION_TYPES.ADD_USER_TO_GOOGLE_GROUP]: 'Add User to Google Group',
  [AUTOMATION_ACTION_TYPES.GRANT_OKTA_GROUP_ACCESS]: 'Grant Okta Group Access',
  [AUTOMATION_ACTION_TYPES.REVOKE_OKTA_GROUP_ACCESS]: 'Revoke Okta Group Access',
  [AUTOMATION_ACTION_TYPES.ASSIGN_OKTA_APPLICATION_ACCESS]: 'Assign Okta Application Access',
  [AUTOMATION_ACTION_TYPES.REVOKE_OKTA_APPLICATION_ACCESS]: 'Revoke Okta Application Access',
  [AUTOMATION_ACTION_TYPES.SUMMARIZE_CONVERSATION]: 'Summarize Conversation',
  [AUTOMATION_ACTION_TYPES.ADD_REACTION_EMOJI]: 'Add Reaction Emoji',
  [AUTOMATION_ACTION_TYPES.CREATE_JIRA_TASK]: 'Create Jira Task',
  [AUTOMATION_ACTION_TYPES.CREATE_CONVERSATION]: 'Create Conversation',
  [AUTOMATION_ACTION_TYPES.GENERATE_AI_MESSAGE]: 'Generate AI Message',
  [AUTOMATION_ACTION_TYPES.CREATE_ESCALATION]: 'Create Escalation',
  [AUTOMATION_ACTION_TYPES.CREATE_PAGERDUTY_PAGE]: 'Create PagerDuty Page',
} as const;

export const CONVERSATION_STATUS_EMOJI_MAP = {
  [CONVERSATION_STATUS.OPEN]: '🔴',
  [CONVERSATION_STATUS.IN_PROGRESS]: '🟠',
  [CONVERSATION_STATUS.ON_HOLD]: '🔵',
  [CONVERSATION_STATUS.CLOSED]: '🟢',
  [CONVERSATION_STATUS.INTAKE]: '⚪',
} as const;

export const STATUS_COLUMN_FORMAT_MAP = {
  open: {
    icon: 'custom-open',
    iconClass: 'status-label-needs-response',
  },
  in_progress: {
    icon: 'custom-in-progress',
    iconClass: 'status-label-in-progress',
  },
  on_hold: {
    icon: 'custom-on-hold',
    iconClass: 'status-label-on-hold',
  },
  closed: {
    icon: 'custom-closed',
    iconClass: 'status-label-closed',
  },
  draft: {
    icon: 'custom-intake',
    iconClass: 'status-label-intake',
  },
};

export const ESCALATION_STATUSES = {
  PENDING: 'pending',
  ACKNOWLEDGED: 'acknowledged',
  RESOLVED: 'resolved',
} as const;

export const ESCALATION_STATUS_LABELS = {
  [ESCALATION_STATUSES.PENDING]: 'Pending',
  [ESCALATION_STATUSES.ACKNOWLEDGED]: 'Acknowledged',
  [ESCALATION_STATUSES.RESOLVED]: 'Resolved',
} as const;

export const PRIVATE_CHANNEL_NAME = '🔒 private-channel';

// Constants for escalation type selector values
export const ESCALATION_TYPE_SELECTOR_VALUES = {
  DISABLED: 0,
  OPTIONAL: 1,
  REQUIRED: 2,
} as const;

export const AI_CONVERSATION_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant',
  TOOL: 'tool',
} as const;
